import { useState } from 'react';
import { Card, Spreadsheet, type Matrix, type CellBase } from '@kss/ui';

const initial: Matrix<CellBase> = [
  [{ value: 'SKU' }, { value: 'Product' }, { value: 'Stock' }, { value: 'Price' }, { value: 'Value' }],
  [{ value: 'A-100' }, { value: 'Laptop' }, { value: '12' }, { value: '55000' }, { value: '660000' }],
  [{ value: 'A-101' }, { value: 'Monitor' }, { value: '25' }, { value: '18000' }, { value: '450000' }],
  [{ value: 'A-102' }, { value: 'Keyboard' }, { value: '80' }, { value: '1500' }, { value: '120000' }],
  [{ value: 'A-103' }, { value: 'Mouse' }, { value: '140' }, { value: '800' }, { value: '112000' }],
  [{ value: '' }, { value: '' }, { value: '' }, { value: '' }, { value: '' }],
];

export default function SpreadsheetPage() {
  const [data, setData] = useState<Matrix<CellBase>>(initial);
  return (
    <div>
      <h1 className="mb-2 text-2xl font-bold tracking-tight">Inventory Spreadsheet</h1>
      <p className="mb-4 text-sm text-[var(--color-text-secondary)]">
        Edit cells directly. Paste from Excel. Keyboard navigation supported.
      </p>
      <Card>
        <Spreadsheet data={data} onChange={setData} />
      </Card>
    </div>
  );
}
